
const STATICALLY_PRELOADED_FONTS = ["Poppins", "Open Sans", "Inter"];
const INDUSTRY_FONT_LINK_ID = "geta-industry-google-font";

const SYSTEM_FONT_NAMES = ["system sans", "system-ui", "-apple-system"];

interface GoogleFontFamilySpec {
  googleFamily: string; // as used in the Google Fonts CSS2 URL (spaces -> +)
  weights: string; // wght@ axis values, e.g. "400;600;700"
}

const GOOGLE_FONT_CONFIG: Record<string, GoogleFontFamilySpec[]> = {
  "Plus Jakarta Sans": [
    { googleFamily: "Plus+Jakarta+Sans", weights: "400;500;600;700" },
  ],
  "DM Sans": [{ googleFamily: "DM+Sans", weights: "400;500;600;700" }],
  Manrope: [{ googleFamily: "Manrope", weights: "400;500;600;700" }],
  Poppins: [{ googleFamily: "Poppins", weights: "400;500;600;700" }],
  "Source Serif 4": [
    { googleFamily: "Source+Serif+4", weights: "400;600;700" },
  ],
};

const extractPrimaryFontName = (fontFamily: string): string => {
  const first = fontFamily.split(",")[0] || "";
  return first.trim().replace(/^["']|["']$/g, "");
};

const buildGoogleFontsUrl = (families: GoogleFontFamilySpec[]): string => {
  const familyParams = families
    .map((f) => `family=${f.googleFamily}:wght@${f.weights}`)
    .join("&");
  return `https://fonts.googleapis.com/css2?${familyParams}&display=swap`;
};

export const ensureIndustryFontLoaded = (fontFamily?: string): void => {
  if (typeof document === "undefined") return;
  if (!fontFamily) return;

  const primaryName = extractPrimaryFontName(fontFamily);
  if (!primaryName) return;
  if (STATICALLY_PRELOADED_FONTS.includes(primaryName)) return;
  if (SYSTEM_FONT_NAMES.includes(primaryName.toLowerCase())) return;

  const families = GOOGLE_FONT_CONFIG[primaryName];
  if (!families) return;

  const href = buildGoogleFontsUrl(families);
  let link = document.getElementById(
    INDUSTRY_FONT_LINK_ID
  ) as HTMLLinkElement | null;
  if (link) {
    if (link.getAttribute("href") !== href) {
      link.setAttribute("href", href);
    }
    return;
  }

  ensurePreconnect(`${INDUSTRY_FONT_LINK_ID}-preconnect-css`, "https://fonts.googleapis.com", false);
  ensurePreconnect(`${INDUSTRY_FONT_LINK_ID}-preconnect-static`, "https://fonts.gstatic.com", true);

  link = document.createElement("link");
  link.id = INDUSTRY_FONT_LINK_ID;
  link.rel = "stylesheet";
  link.href = href;
  document.head.appendChild(link);
};

const ensurePreconnect = (
  id: string,
  href: string,
  crossOrigin: boolean
): void => {
  if (document.getElementById(id)) return;
  const link = document.createElement("link");
  link.id = id;
  link.rel = "preconnect";
  link.href = href;
  if (crossOrigin) link.crossOrigin = "anonymous";
  document.head.appendChild(link);
};

